import { combineReducers } from 'redux'
import addCustomFieldReducer, { addCustomFieldActions } from './addCustomField'
import editCustomFieldReducer, { editCustomFieldActions } from './editCustomField'
import deleteCustomFieldReducer, { deleteCustomFieldActions } from './deleteCustomField'

export const eventProfilesReducers = combineReducers({
    addCustomField: addCustomFieldReducer,
    editCustomField: editCustomFieldReducer,
    deleteCustomField: deleteCustomFieldReducer
})

export const eventProfilesActions = {
    addCustomField: addCustomFieldActions,
    editCustomField: editCustomFieldActions,
    deleteCustomField: deleteCustomFieldActions
}
